import styles from "./Header.module.css";
import ProfileWidget from "components/Navigation/ProfileWidget";
import Logo from "assets/USPA-logo.svg";

const Header = () => {
    return (
        <header className={styles.Header} data-testid="header">
            <div className={styles.Logo} role="img" aria-label="Logo">
                <img src={Logo} alt="USPA Logo" />
            </div>

            <ProfileWidget />
        </header>
    );
};

export default Header;
